import React from 'react';

const HHTInvestment = () => {
  // Ejemplos de sueldos simulados
  const salaryExamples = [
    { position: "Administrativo", salary: "$15,000 - $25,000 MXN", investment: "$6,000 - $10,000 MXN" },
    { position: "Especializado", salary: "$30,000 - $50,000 MXN", investment: "$12,000 - $20,000 MXN" },
    { position: "Gerencial", salary: "$60,000 - $100,000 MXN", investment: "$24,000 - $40,000 MXN" }
  ];

  return (
    <section className="py-20 bg-purple-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-purple-900">Esquema de inversión flexible</h2>
          <p className="text-gray-600 mt-4">Un modelo diseñado para adaptarse a tus necesidades financieras</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {/* Pasos del esquema de inversión */}
          <div className="bg-white p-8 rounded-xl shadow-md text-center">
            <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
              <svg className="w-8 h-8 text-purple-900" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-purple-900 mb-4">Sin anticipo</h3>
            <p className="text-gray-600">
              No requieres hacer ningún pago inicial para comenzar el proceso de búsqueda.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-md text-center">
            <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
              <span className="text-xl font-bold text-purple-900">40%</span>
            </div>
            <h3 className="text-xl font-semibold text-purple-900 mb-4">Al entregar candidato</h3>
            <p className="text-gray-600">
              Pagas solo cuando te presentamos al profesional seleccionado para tu vacante.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-md text-center">
            <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
              <span className="text-xl font-bold text-purple-900">60%</span>
            </div>
            <h3 className="text-xl font-semibold text-purple-900 mb-4">Al mes de contratación</h3>
            <p className="text-gray-600">
              El resto del pago se realiza cuando el candidato completa su primer mes de trabajo.
            </p>
          </div>
        </div>

        {/* Tabla de ejemplos */}
        {/* <div className="bg-white rounded-xl shadow-md overflow-hidden mb-16">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-purple-900 text-white">
              <tr>
                <th className="px-6 py-4 text-left text-sm font-medium uppercase tracking-wider">Posición</th>
                <th className="px-6 py-4 text-left text-sm font-medium uppercase tracking-wider">Rango salarial mensual</th>
                <th className="px-6 py-4 text-left text-sm font-medium uppercase tracking-wider">Inversión aproximada</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {salaryExamples.map((item, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-purple-50'}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.position}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{item.salary}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{item.investment}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div> */}

        {/* Servicio Postventa */}
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-purple-900">Servicio Postventa</h2>
          <p className="text-gray-600 mt-4">Acompañamiento continuo para garantizar el éxito de la contratación</p>
        </div>

        <div className="relative">
          {/* Línea de tiempo */}
          <div className="hidden md:block absolute left-1/2 h-full w-1 bg-purple-200 transform -translate-x-1/2"></div>

          {/* Puntos de la línea de tiempo */}
          <div className="relative space-y-12 md:space-y-20">
            {/* Día 15 */}
            <div className="flex flex-col md:flex-row items-center">
              <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-8 md:ml-8 w-16 h-16 rounded-full bg-purple-100 flex items-center justify-center">
                <span className="text-xl font-bold text-purple-900">15</span>
              </div>
              <div className="md:w-1/2 text-center md:text-left">
                <div className="bg-white p-6 rounded-xl shadow-md">
                  <h3 className="text-xl font-semibold text-purple-900 mb-2">Seguimiento inicial</h3>
                  <p className="text-gray-600">
                    Evaluación del desempeño y adaptación del candidato para todos los niveles.
                  </p>
                </div>
              </div>
              <div className="md:w-1/2"></div> {/* Espacio vacío para alinear */}
            </div>

            {/* Día 30 */}
            <div className="flex flex-col md:flex-row items-center">
              <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-8 md:ml-8 w-16 h-16 rounded-full bg-purple-100 flex items-center justify-center">
                <span className="text-xl font-bold text-purple-900">30</span>
              </div>
              <div className="md:w-1/2"></div> {/* Espacio vacío para alinear */}
              <div className="md:w-1/2 text-center md:text-left">
                <div className="bg-white p-6 rounded-xl shadow-md">
                  <h3 className="text-xl font-semibold text-purple-900 mb-2">Primera evaluación formal</h3>
                  <p className="text-gray-600">
                    Para posiciones especializadas y gerenciales validamos el ajuste cultural y técnico.
                  </p>
                </div>
              </div>
            </div>

            {/* Día 45 */}
            <div className="flex flex-col md:flex-row items-center">
              <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-8 md:ml-8 w-16 h-16 rounded-full bg-purple-100 flex items-center justify-center">
                <span className="text-xl font-bold text-purple-900">45</span>
              </div>
              <div className="md:w-1/2 text-center md:text-left">
                <div className="bg-white p-6 rounded-xl shadow-md">
                  <h3 className="text-xl font-semibold text-purple-900 mb-2">Ajustes finales</h3>
                  <p className="text-gray-600">
                    Para posiciones especializadas, evaluamos la curva de aprendizaje y resultados iniciales.
                  </p>
                </div>
              </div>
              <div className="md:w-1/2"></div> {/* Espacio vacío para alinear */}
            </div>

            {/* Día 60 */}
            <div className="flex flex-col md:flex-row items-center">
              <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-8 md:ml-8 w-16 h-16 rounded-full bg-purple-100 flex items-center justify-center">
                <span className="text-xl font-bold text-purple-900">60</span>
              </div>
              <div className="md:w-1/2"></div> {/* Espacio vacío para alinear */}
              <div className="md:w-1/2 text-center md:text-left">
                <div className="bg-white p-6 rounded-xl shadow-md">
                  <h3 className="text-xl font-semibold text-purple-900 mb-2">Evaluación final</h3>
                  <p className="text-gray-600">
                    Para posiciones gerenciales, revisión completa del impacto en la organización.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HHTInvestment;